import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

/**
 * Gets the name of a recipient to display.
 */
export const getRecipientName = (emailAddress: EmailAddressWrapper): string =>
    emailAddress
        ? emailAddress.Name || emailAddress.OriginalDisplayName || emailAddress.EmailAddress || ''
        : null;

/**
 * Gets the names of attendees to display.
 */
export const getRecipientNames = (recipients: EmailAddressWrapper[]): string[] =>
    recipients?.length ? recipients.map(getRecipientName).filter(recipient => !!recipient) : null;
